// Quotes (#1697). The standard texts of a quote, in the order it prints them.
export const QUOTE_TEXTS = ['intro', 'chapter_1', 'chapter_2', 'chapter_3', 'chapter_4', 'chapter_5', 'terms'] as const;
export type QuoteText = typeof QUOTE_TEXTS[number];

/** The tenant's quote settings: default validity in days and the standard texts per language. */
export interface QuoteSettings {
  validity_days: number;
  texts: Record<string, Record<QuoteText, string>>;
}

export type QuotePricing = 'hours' | 'lines';

/** A row of an opportunity's quote list. */
export interface QuoteListItem {
  id: number;
  number: string;
  title: string;
  quote_date: string;
  expires_on: string;
  printable: boolean;
}

/** A person on the quote. Decimals arrive as strings ("1.50"); the editor sends numbers. */
export interface QuotePerson {
  User_id: number;
  Submission_id: number | null;
  hours: string | number | null;
  rate: string | number | null;
  user?: { id: number; name_first: string; name_last: string } | null;
}

export interface QuotePriceLine {
  description: string;
  amount: string | number | null;
}

/** A quote as the API presents it; `budget` is derived server side, excl. VAT. */
export interface Quote {
  id: number;
  Opportunity_id: number;
  number: string;
  title: string;
  responsible_User_id: number | null;
  quote_date: string;
  expires_on: string;
  locale: string;
  recipient_name: string;
  recipient_address: string | null;
  addressee: string | null;
  salutation: string | null;
  description: string | null;
  texts: Record<QuoteText, string>;
  pricing: QuotePricing;
  start_date: string | null;
  end_date: string | null;
  people: QuotePerson[];
  price_lines: QuotePriceLine[];
  budget: string;
}
